import { Layout, LayoutProps } from "../../../../../app/shared/Models/read";

export interface IntSize {
  x: number;
  y: number;
}

export class CanvasLayout {
  public static readonly minLines: number = 25;
  private static readonly minPadding = 2;
  private static readonly maxPadding = 10;
  private static readonly minCells = 4;

  constructor(readonly lines: IntSize, readonly padding: IntSize) {}

  static create(layoutProps: LayoutProps) {
    const layout = Layout.create(layoutProps);
    const maxUnits = Math.max(...layout.floors.map((x) => x.units.length));
    const cols = maxUnits;
    const rows = layout.floors.length;

    let xLines = (cols + this.minPadding) * this.minCells;
    xLines = Math.ceil(xLines / 5) * 5;
    xLines = Math.max(xLines, this.minLines);

    let yLines = (rows + this.minPadding) * this.minCells;
    yLines = Math.ceil(yLines / 5) * 5;
    yLines = Math.max(yLines, this.minLines);

    const lines = {
      x: xLines,
      y: yLines,
    };

    let xPadding = (xLines - cols * this.minCells) / 2;
    xPadding = Math.min(xPadding, this.maxPadding);
    xPadding = Math.ceil(xPadding / 2) * 2;
    let yPadding = (yLines - rows * this.minCells) / 2;
    yPadding = Math.min(yPadding, this.maxPadding);
    yPadding = Math.ceil(yPadding / 2) * 2;

    const padding = {
      x: xPadding,
      y: yPadding,
    };

    return new CanvasLayout(lines, padding);
  }
}
